import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { fetchRecommendedJobs, getCounters, setAppliedJob } from '../../../actions/jobs';
import RecommendedJob from '../../common/Cards/RecomendedJobCard/RecomendedJobCard';
import style from './finishForm.module.scss';
import Completed from '../../../Assets/images/completed.svg';
import CompleteProfile from '../../pages/CompleteProfile/CompleteProfile';
import colors from '../../../scss/colors';
import { getQuery } from '../../../utils/query';

function FinishForm(props) {
  const dispatch = useDispatch();
  const recommendedJobs = useSelector((state) => state.jobs.recommendedJobs);
  const navigate = useNavigate();
  const [, setSearchParams] = useSearchParams();

  useEffect(() => {
    dispatch(fetchRecommendedJobs());
    dispatch(setAppliedJob(JSON.parse(window.localStorage.getItem('OpenedJobId'))));
    window.localStorage.setItem(`OpenedJobId`, '');
    localStorage.removeItem('OpenedJobId');
    dispatch(getCounters());
    setSearchParams({ ...getQuery(), pagetype: 'finish' });
  }, []);

  const { completedProfile } = props;

  return (
    <>
      <div className={style.head_wrapper}>
        <img alt="Completed" className={style.completed_icon} src={Completed} />
        <h3 className={`${style.header} ${!completedProfile ? style.white_text : ''}`}>Thanks for Applying!</h3>
        <h6 className={`${style.sub_header} ${!completedProfile ? style.white_text : ''}`}>
          Your application has been sent to a recruiter for review.
        </h6>
        <h6
          onClick={() => navigate(`/dashboard/jobs?tab=myjobs&subTab=applied`)}
          aria-hidden="true"
          className={style.sub_header2}
        >
          {completedProfile ? 'View the status of my application' : ''}
        </h6>
      </div>
      {!!recommendedJobs.length && completedProfile && (
        <div className={style.body_wrapper}>
          <p className={style.interest}>You may also be interested in...</p>
          {recommendedJobs.map((job) => (
            <div className={style.rec_job_wrapp} key={job.Id}>
              <RecommendedJob job={job} borderColor={colors.LIGHT_GREY} />
            </div>
          ))}
        </div>
      )}
      {!completedProfile && (
        <div className={style.body_wrapper}>
          <CompleteProfile columnSize={12} contentOffset={0} />
        </div>
      )}
    </>
  );
}

export default FinishForm;
